// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import Search from "@insite/mobius/Icons/Search";
import { alphabetNavigationStyles } from "@steiner/Overrides/Widgets/Brand/AlphabetNavigation";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color, getInputStyleWithIcon, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

alphabetNavigationStyles.container = {
    css: css`
        display: flex;
        justify-content: space-between;
        border: 1px solid ${color("common.border")};
        padding: 12px;
        margin-bottom: 32px;
        column-gap: 30px;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            row-gap: 24px;
        }
    `,
};

alphabetNavigationStyles.titleText = {
    css: css`
        margin-bottom: 9px;
    `,
};

alphabetNavigationStyles.brandsLettersWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
    `,
};

alphabetNavigationStyles.navigationItem = {
    css: css`
        display: inline-flex;
        ${({ enabled }: any) =>
            !enabled &&
            css`
                color: ${color("text.disabled")};
            `}
        ${({ selectedLetter }: any) =>
            selectedLetter &&
            css`
                text-decoration: underline;
                text-decoration-color: ${color("text.link")};
                text-underline-offset: 2px;
            `}
    `,
};

alphabetNavigationStyles.navigationLink = {
    color: "text.main",
    typographyProps: {
        transform: "capitalize",
        forwardAs: "span",
        size: 16,
        lineHeight: "26px",
        weight: fontConfig.weight.bold,
        mergeCss: true,
        css: css`
            text-align: center;
            display: block;
        `,
    },
    css: css`
        &:focus {
            outline: none;
        }
    `,
};

alphabetNavigationStyles.navigationTextEmpty = {
    transform: "capitalize",
    variant: "headerTertiary",
    forwardAs: "span",
    lineHeight: "26px",
    weight: fontConfig.weight.bold,
    css: css`
        text-align: center;
        display: block;
        opacity: 0.5;
        cursor: not-allowed;
    `,
};

alphabetNavigationStyles.filterInput = {
    ...getInputStyleWithIcon(),
};

alphabetNavigationStyles.alphabetNavigationContainer = {
    css: css`
        width: 100%;
    `,
};

alphabetNavigationStyles.searchNameContainer = {
    css: css`
        flex-shrink: 0;
        width: 100%;
        max-width: 644px;
        ${xScreen("lte", "md")} {
            max-width: 100%;
        }
    `,
};
